<template>
  <div id="feedbackModule">
    <div id="feedbacks" v-if="list">
      <v-container class="pa-0">
        <v-layout>
          <router-link to="feedbacks/add">
          <v-flex class="xs12 sm12 mb-5">
            <v-btn fab absolute right class="mr-3 pf-btn-fab">
              <v-icon>add</v-icon>
            </v-btn>
          </v-flex>
          </router-link>
        </v-layout>       
      </v-container>
      <v-card-title>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
      </v-card-title>
      <v-card class="mt-3">
        <v-data-table
          :headers="headers"
          :items="Feedback"
          :search="search"
          :pagination.sync="pagination"
          class="pf-data-table"
        >
          <template v-slot:items="props">
            <td>{{ (props.item.account ? props.item.account.name : '') }}</td>
            <td>{{ (props.item.account ? props.item.account.ppn : '') }}</td>
            <td>{{ (props.item.account ? formatDate(props.item.account.createdAt) : '') }}</td>
            <td>{{ (props.item.account && props.item.account.profile_status ? props.item.account.profile_status.join(' / ') : '') }}</td>
            <td>{{ getRating(props.item.rating) }}</td>
            <td align="right">
              <v-btn icon class="ma-0" @click="editItem(props.item)">
                <v-icon size="22" color="grey darken-2">edit</v-icon>
              </v-btn>
            </td>
          </template>
        </v-data-table>
      </v-card>
    </div>
    <div id="feebackEdit" v-if="!list">
      <v-container class="pa-0">
      <v-layout>
        <v-flex class="xs12 sm12 mb-5">
          <v-btn fab absolute left @click="backToListing" class="ml-3 pf-btn-fab">
            <v-icon>arrow_back</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-container>
    <v-form ref="feedBackComment">
    <v-container class="-border">
      <v-layout wrap>
        <v-flex xs12 class="button-container pr-4 text-xs-right">
          <div class="d-inline-flex" v-if="selectedData">
            <v-btn class="pf-btn pf-btn-cancel" @click="hideButtons">
              <v-icon size="16" class="pr-1">cancel</v-icon>
              <div>Cancel</div>
            </v-btn>
            <v-btn class="pf-btn pf-btn-save" @click="save">
              <v-icon size="16" class="pr-1">check_circle</v-icon>
              <div>Save</div>
            </v-btn>
          </div>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex>
          <div id="pageEditor">
            <v-container grid-list-xl fluid>
              <v-layout row wrap>
                <v-flex sm12>
                  <quill-editor
                    :content="content"
                    :options="editorOption"
                    @input="changedData"
                    v-model="editableItem.comment"
                  >
                  </quill-editor>
                </v-flex>
              </v-layout>
            </v-container>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
    <v-container class="pt-4">
      <v-layout>
        <v-flex xs12 class="button-container pr-4 text-xs-right">
          <div class="d-inline-flex" v-if="selectedData">
            <v-btn class="pf-btn pf-btn-cancel" @click="hideButtons">
              <v-icon size="16" class="pr-1">cancel</v-icon>
              <div>Cancel</div>
            </v-btn>
            <v-btn class="pf-btn pf-btn-save" @click="save">
              <v-icon size="16" class="pr-1">check_circle</v-icon>
              <div>Save</div>
            </v-btn>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
    </v-form>
    </div>
  </div>
</template>
<script>
/* global session store config */
import { getCollection, formatDate, update } from '../../helpers/helpers';
import { mapGetters } from 'vuex';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import { quillEditor } from 'vue-quill-editor';
import swal from 'sweetalert2';

// This lists the feedbacks to the admin
export default {
  name: 'ListFeedback',
  components: {
    quillEditor
  },
  data: () => ({
    editableItem: {},
    selectedData: false,
    list: true,
    search: '',
    entity: 'Feedback',
    editIndex: -1,
    pagination: {
      sortBy: 'date', // The field that you're sorting by
      descending: true,
      rowsPerPage: config.dom.rowsPerPage
    },
    content: '',
    editorOption: {
      placeholder: 'Add Feedback comment here...',
    },
    headers: [
      { text: 'Family Name', value: 'account.name', align: 'left' },
      { text: 'PPN', value: 'account.ppn' },
      { text: 'Join Date', value: 'date' },
      { text: 'Status', value: 'account.profile_status' },
      { text: 'Rating', value: 'rating' },
      { text: '', sortable: false }
    ],
    ratingOptions: [{ text: 'Wow', value: 5 },
      { text: 'Very Good', value: 4 },
      { text: 'Satisfactory', value: 3 },
      { text: 'Not Bad', value: 2 },
      { text: 'Bad', value: 1 }],
  }),
  computed: {
    ...mapGetters(['Feedback'])
  },
  beforeRouteEnter (to, from, next) {
    if (!session.isOnline()) {
      next({ path: '/login' });
    } else {
      next();
    }
  },
  created () {
    this.initialize();
  },
  methods: {
    // @vuese
    // Used to show the form buttons
    changedData () {
      this.selectedData = true;
    },
    // @vuese
    // Used to hide the form buttons
    hideButtons () {
      window.getApp.$emit('pageSubHeader', '');
      this.selectedData = false;
      this.list = true;
    },
    // @vuese
    // Used to go back to the feedback list
    backToListing () {
      window.getApp.$emit('pageSubHeader', '');
      this.list = true;
      this.editIndex = -1;
    },
    // @vuese
    // Used to setup the feedback edit
    // @arg The feedback item object to be edited
    editItem (item) {
      this.editIndex = this.Feedback.indexOf(item);
      this.list = false;
      this.editableItem = { ...item };
      window.getApp.$emit('pageSubHeader', 'Comment Edit');
    },
    // @vuese
    // Used to fetch the feedback list if not exists
    async initialize () {
      if (!this.Feedback.length) {
        let { error, data } = await getCollection(this.entity, true);
        if (error) {
          console.log(error);
        } else {
          if (data.length > 0) {
            store.commit('setFeedback', data);
          }
        }
      }
    },
    // @vuese
    // Used to get the rating text
    getRating (ratingValue) {
      let result = this.ratingOptions.find(item => item.value === ratingValue);
      return result.text;
    },
    // @vuese
    // Used to format the mongo date string
    // @arg The mongo date string
    formatDate (dateString) {
      if (dateString) {
        return formatDate(dateString, 'MM/DD/YYYY');
      }
    },
    // @vuese
    // Used to save the edited feedback
    async save () {
      if (this.$refs.feedBackComment.validate()) {
        if (!this.editableItem.comment.replace(/(<([^>]+)>)/ig, '').replace(/\s/g, '').length) {
          swal.fire({
            type: 'warning',
            title: 'Content is required.',
            text: 'Please add feeback comment!',
            showConfirmButton: true,
            confirmButtonColor: '#3085d6',
            confirmButtonText: 'OK'
          });
          return;
        }
        this.selectedData = false;
        let postData = {
          rating: this.editableItem.rating,
          comment: this.editableItem.comment,
          account: this.editableItem.account.id
        };
        let id = this.editableItem.id;
        let { error, data } = await update('Feedback', postData, id);
        if (error) {
          this.selectedData = true;
          console.log('error', error);
        } else {
          this.Feedback[this.editIndex] = data;
          this.loading = false;
          swal.fire({
            type: 'success',
            title: 'Feedback comment update successfully',
            showConfirmButton: false,
            timer: 2500,
            onClose: () => {
              this.editIndex = -1;
              this.list = true;
              window.getApp.$emit('pageSubHeader', '');
            }
          });
        }
      }
    }
  }
};
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Feedbacks/list.vue